<template>
    <div>
        <div v-if="isLoading" class="col-12">
            <!-- begin loader -->
            <beat-loader-component v-if="isLoading" :isLoading="isLoading"></beat-loader-component>
            <!-- end loader -->
        </div>
        <form v-else class="row" @submit.prevent="submitRewrite">
            <div class="col-md-12 text-center">
                <errors v-if="errors_msg?.message">
                    {{ errors_msg.message }}
                </errors>
            </div>
            <div class="col-12 col-md-6">
                <label class="akkurate-dark small" for="date">From Date</label>
                <b-form-group label-for="start_date" class="akkurate-dark">
                    <b-form-input id="start_date" class="mt-2 field-container fields" type="date"
                        v-model="form.start_date">
                    </b-form-input>
                </b-form-group>
            </div>

            <div class="col-12 col-md-6">
                <label class="akkurate-dark small" for="date">To Date</label>
                <b-form-group label-for="end_date" class="akkurate-dark">
                    <b-form-input id="end_date" class="mt-2 field-container fields" type="date" v-model="form.end_date">
                    </b-form-input>
                </b-form-group>
            </div>
            <hr class="mt-4" />
            <div class="col-12 text-end">
                <button type="submit" :disabled="isSaving" class="btn akkurate-green-btn text-white btn-size my-2 me-3">
                    <span class="small">
                        <span v-if="isSaving">
                            <b-spinner small class="align-middle"></b-spinner>
                        </span>
                        <font-awesome-icon v-else class="me-2" :icon="['fas', 'save']" />
                        Rewrite
                    </span>
                </button>
            </div>

        </form>
    </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
export default {
    data() {
        return {
            form: {
                start_date: this.getBeginningOfYear(),
                end_date: this.getOneMonthAfterSelected(this.getBeginningOfYear()),
            },
            isLoading: false,
            errors_msg: {},
            isSaving: false,

        }
    },
    methods: {
        async submitRewrite() {
            this.isSaving = true
            await ApiService.post("/finance/coa-transactions/rewrite", this.form).then((response) => {
                // this.rows = response.data.data;
                console.log(response);
                this.$Progress.finish();
                this.$emit("submitRewrite");
                this.isSaving = false
            }).catch((error) => {
                // console.log(error);
                this.isLoading = false;
                this.$Progress.fail();
                this.isSaving = false
            }).finally(() => {
                this.isLoading = false;
                this.$Progress.finish();
                this.isSaving = false
            });

        },
    }
}

</script>